<template>
<v-data-table :headers="headers" :items="desserts" :loading="loading" sort-by="calories" class="elevation-0 mt-7">
    <template v-slot:top>
        <v-toolbar flat color="white">
            <v-toolbar-title>Team</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>

            <!-- dialog box add/edit/delete/active/pending -->

            <v-dialog v-model="newMember" max-width="500px" content-class="modal-right">
                <template v-slot:activator="{ on }">
                    <v-btn v-if="CrrentUser != 'member'" color="primary" dark class="mb-2 text-capitalize" v-on="on">Add New Member</v-btn>
                </template>
                <v-card class="cus-card" flat>
                    <v-card-title class="grey--text darken-3 pa-4 mb-4">
                        <v-avatar slot="icon" class="mr-3" color="primary accent-4" size="40">
                            <v-icon icon="mdi-lock" color="white">
                                mdi-account-plus
                            </v-icon>
                        </v-avatar>
                        <span class="headline">Add New Member</span>
                    </v-card-title>
                    <v-card-text class="pb-0">
                        <v-form ref="form" v-model="valid1" lazy-validation>
                            <v-row>
                                <v-col cols="12" class="py-0">
                                    <v-text-field class="border-radius" outlined dense :rules="Rules" v-model="defaultItem.name" label="Name"></v-text-field>
                                </v-col>
                                <v-col cols="12" class="py-0">
                                    <v-text-field class="border-radius" outlined dense :rules="emailRules" type="email" v-model="defaultItem.email" label="Email"></v-text-field>
                                </v-col>
                                <v-col cols="12" class="py-0">
                                    <v-text-field class="border-radius" outlined dense :rules="Rules" v-model="defaultItem.password" :append-icon="passwardShow ? 'mdi-eye' : 'mdi-eye-off'" :type="passwardShow ? 'text' : 'password'" @click:append="passwardShow = !passwardShow" label="Password"></v-text-field>
                                </v-col>
                                <v-col cols="12" class="py-0">
                                    <v-select class="border-radius text-capitalize" :rules="Rules" v-if="CrrentUser == 'admin' && isOwner" :items="owner" v-model="defaultItem.type" label="Type" outlined dense></v-select>
                                    <v-select class="border-radius text-capitalize" :rules="Rules" v-if="CrrentUser == 'admin' && !isOwner" :items="admin" v-model="defaultItem.type" label="Type" outlined dense></v-select>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                    <v-card-actions class="pa-4">
                        <v-btn color="primary" class="text-capitalize" :loading="onTrue" @click="addMember">Save</v-btn>
                        <v-btn color="grey darken-1" class="text-capitalize" text @click="close">Cancel</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="edit" persistent max-width="500px" content-class="modal-right">
                <v-card class="cus-card" flat>
                    <v-card-title class="grey--text pa-4 mb-4">
                        <v-avatar slot="icon" class="mr-3" color="primary accent-4" size="40">
                            <v-icon icon="mdi-lock" color="white">
                                mdi-circle-edit-outline
                            </v-icon>
                        </v-avatar>
                        <span class="headline">Edit Member</span>
                    </v-card-title>
                    <v-card-text class="pb-0">
                        <v-form ref="edit" v-model="valid" lazy-validation>
                            <v-row>
                                <v-col cols="12" class="py-0">
                                    <v-text-field class="border-radius" :rules="Rules" outlined dense v-model="editedItem.name" label="Name"></v-text-field>
                                </v-col>
                                <v-col cols="12" class="py-0">
                                    <v-text-field class="border-radius" :rules="Rules" disabled outlined dense v-model="editedItem.email" label="Email"></v-text-field>
                                </v-col>
                                <!-- <v-col cols="12" class="py-0">
                                    <v-text-field class="border-radius" :rules="Rules" type="number" outlined v-model="editedItem.phone" label="Phone"></v-text-field>
                                </v-col> -->
                                <v-col cols="12" class="py-0">
                                    <v-select class="border-radius text-capitalize" :rules="Rules" v-if="CrrentUser == 'admin' && isOwner" :items="owner" v-model="editedItem.type" label="Type" outlined dense></v-select>
                                    <v-select class="border-radius text-capitalize" :rules="Rules" v-if="CrrentUser == 'admin' && !isOwner" :items="admin" v-model="editedItem.type" label="Type" outlined dense></v-select>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>

                    <v-card-actions class="pa-4">
                        <v-btn color="primary" class="text-capitalize" :loading="onTrue" @click="EditMember(editedItem)">Save</v-btn>
                        <v-btn color="grey darken-1" class="text-capitalize" text @click="edit = false">Cancel</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="Delete" max-width="500px">
                <v-card flat>
                    <v-alert text prominent type="error" icon="mdi-delete">
                        <v-card-title class="title text-capitalize pa-0" primary-title>
                            {{ editedItem.name }}
                        </v-card-title>
                        Are you sure you want to <b>Delete</b> this member?
                    </v-alert>
                    <v-card-actions class="pa-4 pt-0">
                        <v-spacer></v-spacer>
                        <v-btn color="red" class="text-capitalize" text :loading="onTrue" @click="deleteItem(editedItem)">
                            Delete
                        </v-btn>
                        <v-btn color="grey darken-1" class="text-capitalize" text @click="Delete = false">Cancel</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="Active" max-width="500px">
                <v-card flat>
                    <v-alert text prominent type="success" icon="mdi-checkbox-marked-circle-outline">
                        <v-card-title class="title text-capitalize pa-0" primary-title>
                            {{ editedItem.name }}
                        </v-card-title>
                        Are you sure you want to <b>Active</b> this member?
                    </v-alert>
                    <v-card-actions class="pa-4 pt-0">
                        <v-spacer></v-spacer>
                        <v-btn color="success" class="text-capitalize" text :loading="onTrue" @click="activeBox(editedItem)">
                            Active
                        </v-btn>
                        <v-btn color="grey darken-1" class="text-capitalize" text @click="Active = false">Cancel</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="Pending" max-width="500px">
                <v-card flat>
                    <v-alert text prominent type="warning" icon="mdi-close-circle-outline">
                        <v-card-title class="title text-capitalize pa-0" primary-title>
                            {{ editedItem.name }}
                        </v-card-title>
                        Are you sure you want to <b>disabled</b> this member?
                    </v-alert>
                    <v-card-actions class="pa-4 pt-0">
                        <v-spacer></v-spacer>
                        <v-btn color="warning" class="text-capitalize" text :loading="onTrue" @click="penddingBox(editedItem)">
                            disabled
                        </v-btn>
                        <v-btn color="grey darken-1" class="text-capitalize" text @click="Pending = false">Cancel</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!-- dialog end -->
        </v-toolbar>
        <v-divider></v-divider>
    </template>
    <template v-slot:item.name="{ item }">
        <span class="text-capitalize">
            {{item.name}}
        </span>
    </template>
    <template v-slot:item.role="{ item }">
        <v-chip small class="text-capitalize" color="primary" label>
            <v-icon left>mdi-label</v-icon>
            {{item.type}}
        </v-chip>
    </template>
    <template v-slot:item.status="{ item }">
        <v-chip v-if="item.status == 'paused'" small :class="`${item.status} text-capitalize`" outlined label>
            Inactive
        </v-chip>
        <v-chip v-if="item.status == 'pending'" small :class="`${item.status} text-capitalize`" outlined label>
            Inactive
        </v-chip>
        <v-chip v-if="item.status == 'active'" small :class="`${item.status} text-capitalize`" outlined label>
            {{item.status}}
        </v-chip>
    </template>
    <template v-slot:item.action="{ item }">
        <span v-if="CrrentUser != 'member' || isOwner">
            <div class="d-flex justify-end">
                <v-btn @click="active(item)" v-if="item.status != 'active'" class="mr-4" icon text>
                    <v-icon small>
                        mdi-checkbox-marked-circle-outline
                    </v-icon>
                </v-btn>
                <v-btn @click="pending(item)" v-else icon text class="mr-4">
                    <v-icon small>
                        mdi-close-circle-outline
                    </v-icon>
                </v-btn>
                <v-btn @click="editItem(item)" class="mr-4" icon text>
                    <v-icon small>
                        mdi-pencil
                    </v-icon>
                </v-btn>
                <v-btn @click="deleteModal(item)" icon text>
                    <v-icon small>
                        mdi-delete
                    </v-icon>
                </v-btn>
            </div>
        </span>
    </template>
</v-data-table>
</template>

<script>
import {
    mapActions,
    mapMutations
} from 'vuex'
export default {
    data: () => ({
        loading: false,
        newMember: false,
        edit: false,
        Delete: false,
        Pending: false,
        Active: false,
        onTrue: false,
        passwardShow: false,
        valid1: true,
        valid: true,
        CrrentUser: '',
        editBox: false,
        isOwner: '',
        emailRules: [
            v => !!v || 'E-mail is required',
            v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],
        Rules: [
            v => !!v || 'Field is required',
        ],
        owner: ['admin', 'member'],
        admin: ['member'],
        headers: [{
                text: 'Name',
                value: 'name'
            },
            {
                text: 'Email',
                value: 'email'
            },
            {
                text: 'Role',
                value: 'role'
            },
            {
                text: 'Status',
                value: 'status'
            },
            {
                text: 'Actions',
                align: 'right',
                value: 'action',
                sortable: false
            },
        ],
        desserts: [],
        editedIndex: -1,
        editedItem: {
            name: '',
            email: '',
            role: '',
            status: '',
            phone: '',
        },
        defaultItem: {
            name: '',
            email: '',
            password: '',
            type: ''

        },
    }),

    watch: {
        dialog(val) {
            val || this.close()
        },
    },

    async mounted() {
        this.CrrentUser = JSON.parse(window.localStorage.getItem('user')).type
        this.isOwner = JSON.parse(window.localStorage.getItem('user')).owner
        await this.initialize()
    },

    methods: {
        ...mapMutations(['SnackbarSuccess']),
        ...mapActions(['DeleteResponse', 'PostResponse', 'PutResponse', 'GetResponse']),
        NewClose() {
            this.defaultItem = []
            this.$refs.form.resetValidation()
            this.MemberBoxClose()
        },
        async initialize() {
            this.loading = false
            try {
                let url = '/internal/v2/member'
                const data = (await this.GetResponse(url)).data
                if (data.success) {
                    this.desserts = data.data.members
                    this.loading = false
                }
            } catch (err) {
                let dataMsg = {
                    success: true,
                    message: err.response.data.errors[0].message,
                    action: 'error'
                }
                this.SnackbarSuccess(dataMsg)
                this.loading = false
            }
        },

        active(item) {
            this.Active = true
            this.editedIndex = this.desserts.indexOf(item)
            this.editedItem = Object.assign({}, item)
        },

        async activeBox(item) {
            console.log(item)
            this.onTrue = true
            try {
                let value = {
                    url: `/internal/v2/member/${item._id}/detail`,
                    data: {
                        "name": item.name,
                        "status": "active",
                        "type": item.type
                    }
                }
                const data = (await this.PostResponse(value)).data
                if (data.success) {
                    this.SnackbarSuccess(data)
                    this.initialize()
                    this.onTrue = false
                    this.Active = false
                }
            } catch (err) {
                let dataMsg = {
                    success: true,
                    message: err.response.data.errors[0].message,
                    action: 'error'
                }
                this.SnackbarSuccess(dataMsg)
                this.onTrue = false
            }
        },

        pending(item) {
            this.editedIndex = this.desserts.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.Pending = true
        },
        async penddingBox(item) {
            this.onTrue = true
            try {
                let value = {
                    url: `/internal/v2/member/${item._id}/detail`,
                    data: {
                        "name": item.name,
                        "status": "paused",
                        "type": item.type
                    }
                }
                const data = (await this.PostResponse(value)).data
                if (data.success) {
                    this.SnackbarSuccess(data)
                    this.initialize()
                    this.onTrue = false
                    this.Pending = false
                }
            } catch (err) {
                let dataMsg = {
                    success: true,
                    message: err.response.data.errors[0].message,
                    action: 'error'
                }
                this.SnackbarSuccess(dataMsg)
                this.onTrue = false
            }
        },

        deleteModal(item) {
            this.editedIndex = this.desserts.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.Delete = true
        },

        async deleteItem(item) {
            this.onTrue = true
            try {
                let urlId = `/internal/v2/member/${item._id}`
                const data = (await this.DeleteResponse(urlId)).data
                if (data.success) {
                    this.SnackbarSuccess(data)
                    this.initialize()
                    this.onTrue = false
                    this.Delete = false
                }
            } catch (err) {
                let dataMsg = {
                    success: true,
                    message: err.response.data.errors[0].message,
                    action: 'error'
                }
                this.SnackbarSuccess(dataMsg)
                this.onTrue = false
            }
        },

        editItem(item) {
            this.editedIndex = this.desserts.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.edit = true

        },

        async EditMember(item) {
            if (this.$refs.edit.validate()) {
                this.onTrue = true
                try {
                    let value = {
                        url: `/internal/v2/member/${item._id}/detail`,
                        data: {
                            "name": item.name,
                            "status": item.status,
                            "type": item.type
                        }
                    }
                    const data = (await this.PostResponse(value)).data
                    if (data.success) {
                        this.SnackbarSuccess(data)
                        this.initialize()
                        this.onTrue = false
                        this.edit = false
                    }
                } catch (err) {
                    let dataMsg = {
                        success: true,
                        message: err.response.data.errors[0].message,
                        action: 'error'
                    }
                    this.SnackbarSuccess(dataMsg)
                    this.onTrue = false
                }
            }
        },
        close() {
            this.defaultItem = {}
            this.newMember = false
            this.$refs.form.resetValidation()
        },
        async addMember() {
            if (this.$refs.form.validate()) {
                this.onTrue = true
                try {
                    let value = {
                        url: '/internal/v2/member',
                        data: this.defaultItem
                    }
                    const data = (await this.PutResponse(value)).data
                    if (data.success) {
                        this.SnackbarSuccess(data)
                        this.initialize()
                        this.close()
                        this.onTrue = false
                        this.newMember = false
                    }
                } catch (err) {
                    let dataMsg = {
                        success: true,
                        message: err.response.data.errors[0].message,
                        action: 'error'
                    }
                    this.SnackbarSuccess(dataMsg)
                    this.onTrue = false
                }
            }
        }
    }
}
</script>

<style scoped>
.pending {
    color: orange !important;
    caret-color: orange !important;
    border-color: orange !important;
}

.disabled {
    color: orange !important;
    caret-color: orange !important;
    border-color: orange !important;
}

.paused {
    color: orange !important;
    caret-color: orange !important;
    border-color: orange !important;
}

.active {
    color: green !important;
    caret-color: green !important;
    border-color: green !important;
}
</style>
